// RUNN — shared bootstrap for the legal pages.
// Wires the "Manage privacy choices" button, primes consent state, registers the SW.
import { openPreferences } from '../compliance/consent-banner.js';
import { primeConsentAttributes } from '../compliance/consent.js';
import { registerSW } from '../pwa/register-sw.js';

primeConsentAttributes();
window.__runnOpenPrefs = openPreferences;
registerSW();
